import React from 'react'
import { Platform, View, Text } from 'react-native'
import { useAppDispatch, useAppSelector } from '../../state/hooks'
import { CardElement, useStripe } from '@stripe/react-stripe-js'
import { setCheckoutState } from '../../state/Slices/checkoutSlice'
import { SquarePaymentForm } from '../Square/SquarePaymentForm.web'
import { SMALL_WIDTH } from '../../constants/GlobalStyle'
import { ORGANIZATION_IDS } from '../../global'

interface WebCardDetails {
	paymentProvider: string
	setIsCardValid?: (valid: boolean) => void
	title?: string
	onPress?: any
}

export const CARD_ELEMENT_OPTIONS = {
	style: {
		base: {
			color: '#32325d',
			fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
			fontSmoothing: 'antialiased',
			fontSize: !SMALL_WIDTH ? '18px' : '15px',
			'::placeholder': {
				color: '#626970',
			},
		},
		invalid: {
			color: '#fa755a',
			iconColor: '#fa755a',
		},
	},
}

export function WebCardElement(props: WebCardDetails) {
	const { paymentProvider, setIsCardValid = null, title = '', onPress = null } = props
	const { cardErrorMessage } = useAppSelector(state => state.checkout)
	const dispatch = useAppDispatch()
	const stripe = useStripe()

	const enableAutoPaymentForCypress = process.env.NODE_ENV === 'test'

	// Test Foodhall only payment handler for Cypress testing
	const handleDevPayment = async () => {
		if (!stripe) return

		try {
			// Clear any existing error messages
			dispatch(setCheckoutState({ cardErrorMessage: '' }))

			// Set card as valid - this is what the CardElement onChange does
			if (setIsCardValid) {
				setIsCardValid(true)
			}

			// Set a flag for the payment flow to know we're in staging site
			if (enableAutoPaymentForCypress) {
				;(window as any).__DEV_PAYMENT_MODE = true
			}

			console.log('Dev payment: Card marked as valid for Stripe processing')
		} catch (error) {
			console.error('Dev payment error:', error)
			dispatch(setCheckoutState({ cardErrorMessage: 'Dev payment failed' }))
		}
	}

	if (Platform.OS === 'web') {
		return (
			<>
				{paymentProvider === 'stripe' ? (
					<>
						<View
							style={{
								backgroundColor: '#f2f2f2',
								borderColor: '#b2b2b2',
								borderWidth: 1,
								borderRadius: 5,
								paddingVertical: 12,
								paddingHorizontal: 10,
							}}
						>
							<CardElement
								options={CARD_ELEMENT_OPTIONS}
								onChange={cardDetails => {
									if (cardDetails.error) {
										dispatch(setCheckoutState({ cardErrorMessage: cardDetails.error.message }))
									} else {
										dispatch(setCheckoutState({ cardErrorMessage: '' }))
									}
									setIsCardValid(cardDetails.complete && cardDetails.error === undefined)
								}}
							/>
						</View>
						{cardErrorMessage && (
							<Text style={{ color: 'red', marginTop: 4 }}>{cardErrorMessage}</Text>
						)}

						{/* Dev-only payment button for Cypress testing */}
						{enableAutoPaymentForCypress && (
							<View style={{ marginTop: 10 }}>
								<button
									data-testid="dev-payment-button"
									onClick={handleDevPayment}
									style={{
										backgroundColor: '#007bff',
										color: 'white',
										border: 'none',
										borderRadius: 4,
										padding: '8px 16px',
										fontSize: '14px',
										cursor: 'pointer',
									}}
								>
									Use Test Card (enabled for staging sites)
								</button>
							</View>
						)}
					</>
				) : (
					<SquarePaymentForm title={title} onPress={onPress} />
				)}
			</>
		)
	}
}

export function MobileCardElement(props: any) {
	return <></>
}
